<vitens-taskforce>
	<p body>
		De verbinding is verbroken. Er wordt automatisch geprobeerd een nieuwe verbinding te maken.
	</p>
	<br />
	<p>
		Klik op ‘Terug’ om de verbinding handmatig op te zetten.
	</p>
</vitens-taskforce>